module.exports = __webpack_public_path__ + "static/media/bath.223af49b.svg";